import './MultiNodesPanel.scss';
import { TabPanel, TabView } from 'primereact/tabview';
import { useState } from 'react';
import { DataNodeModel, NodeKind } from '../../diagram/nodes/DataNodeModel';
import { StepByStep } from '../../../../components/StepByStep/StepByStep';
import { useGraph } from '../../../../hooks/useGraph';

export const MultiNodesPanel = () => {

    const { engine } = useGraph();
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

    const getSelectedNodes = (): DataNodeModel[] => {
      return engine?.getModel().getSelectedEntities().filter((currentDatanode) =>
          { return (currentDatanode && Object.prototype.hasOwnProperty.call(currentDatanode, "kind"))}
    ) as DataNodeModel[];
    }

    return (
        <div className="multi-nodes-panel">
          <div className="nodes-name">
            {getSelectedNodes().map((node) => {
              return <span className="node-name">
                {node.kind !== NodeKind.NOTE ? node.getName() : 'Commentaire'} &nbsp;
                <span className="node-id">#{node.getID()}</span>
              </span>
            })}
          </div>
        </div>
    );
};
